import { Random } from "random";
import data from "./dictionary.json";

const dictionary = data as unknown as Record<string, string[]>;

export function HashString(s: string): number {
	let hash = 0;
	for (const char of s) {
		hash = (hash << 5) - hash + char.charCodeAt(0);
		hash |= 0;
	}
	return hash;
}

const RAND = new Random();

export function MultipleRandomChoice<T>(
	items: T[],
	values: number,
	defaultValue: T,
	rand: Random = RAND
): T[] {
	const v: T[] = [];
	for (let i = 0; i < values; i++) {
		v.push(rand.choice(items) ?? defaultValue);
	}
	return v;
}

export function GetRandomSeedNumber(): number {
	return Date.now() ^ (Math.random() * 0x100000000);
}

export function GetRandomSeedString(
	words: number = 4,
	sep: string = "-"
): string {
	return MultipleRandomChoice(
		Object.keys(dictionary).filter((key) => !key.startsWith("$")),
		words,
		"INVALID"
	)
		.map((k) => dictionary[k])
		.map((d) => RAND.choice(d) ?? "INVALID")
		.join(sep);
}

export type Seedlike = string | number | null | undefined;

function FixSeed(seed: Seedlike) {
	if (seed === undefined || seed === null) {
		seed = GetRandomSeedNumber();
	}

	if (typeof seed === "string") {
		seed = HashString(seed);
	}

	return seed;
}

export function NewRNG01(seed?: Seedlike): () => number {
	seed = FixSeed(seed);

	return new Random(seed).uniform(0, 1);
}

export function NewRandInt(min: number, max: number, seed?: Seedlike): ()=>number {
	seed = FixSeed(seed);
	return new Random(seed).uniformInt(min, max);
}

export function NewRandomChoice<T>(items: ArrayLike<T>, seed?: Seedlike): ()=>T {
	const randIndex = NewRandInt(0, items.length-1, seed);
	return ()=>{
		return items[randIndex()]
	}
}

export function NewRandomStringLiteral<T extends string>(seed: Seedlike, ...items: T[]): ()=>T {
	const randIndex = NewRandInt(0, items.length-1, seed);
	return ()=>{
		return items[randIndex()]
	}
}